import {
  SAVE_DOCS_FORM_DATA,
  SAVE_REFIDOCS_FORM_DATA,
  SUBMIT_DOC,
  SUBMIT_DOC_SUCCESS,
  SUBMIT_DOC_FAILED,
  SUBMIT_REFIDOC,
  SUBMIT_REFIDOC_SUCCESS,
  SUBMIT_REFIDOC_FAILED,
  CLEAR_DOCS_ERROR,
  FEES_ERROR,
  CLEAR_MULTI_FORM_FEES_ERROR,
  DOWNLOAD_ALL,
  DOWNLOAD_ALL_SUCCESS,
  DOWNLOAD_ALL_FAILED,
  GET_LIEN_HOLDER_INFO,
  CLEAR_DOCS_RESPONSE,
} from './types';

const INITIAL_STATE = {
  docsResponse: {},
  transactionId: null,
  type: null,
  lienInformation: null,
  notes: null,
  isLoading: false,
  error: null,
  loading: false,
  docsFormData: {}
};

const docsReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case SAVE_DOCS_FORM_DATA:
      return {
        ...state,
        docsFormData: payload,
      };

    case SAVE_REFIDOCS_FORM_DATA:
      return {
        ...state,
        refiDocsFormData: payload,
      };

    case SUBMIT_DOC:
    case SUBMIT_REFIDOC:
      return {
        ...state,
        isLoading: true,
      };
    case SUBMIT_DOC_SUCCESS:
      return {
        ...state,
        docsResponse: payload,
        transactionId: payload.TransactionID,
        type: payload.Type,
        isLoading: false,
        error: null,
      };

    case SUBMIT_REFIDOC_SUCCESS:
      return {
        ...state,
        transactionId: payload.TransactionID,
        type: payload.Type,
        docsResponse: payload,
        isLoading: false,
        error: null,
      };

    case SUBMIT_DOC_FAILED:
    case SUBMIT_REFIDOC_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload.error || payload,
      };

    case CLEAR_DOCS_ERROR:
      return {
        ...state,
        error: null
      }

    case FEES_ERROR:
      return {
        ...state,
        feesError: payload.error || payload,
      }

    case CLEAR_MULTI_FORM_FEES_ERROR:
      return {
        ...state,
        feesError: null,
      }

    case DOWNLOAD_ALL:
      return {
        ...state,
        loading: true,
      }

    case DOWNLOAD_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case DOWNLOAD_ALL_FAILED:
      return {
        ...state,
        loading: false,
      }

    case GET_LIEN_HOLDER_INFO:
      return {
        ...state,
      }

    case CLEAR_DOCS_RESPONSE:
      return {
        ...state,
        docsResponse: {},
        type: null,
      }

    default:
      return state;
  }
};

export default docsReducer;
